<template>
  <div id="PageLayout">
    <div v-if="!$store.state.loadingApp">
      <jcdc-brand-bar
        :app-title="$store.state.appTitle"
        :app-subtitle="$store.state.appSubtitle"
        :user-info="$store.getters.userInfo"
        :utility-list="utilityList"
        :app-environment="$store.state.appEnvironment"
      />
      <!-- TODO: Setup - Remove example click event -->
      <jcdc-nav-router
        :loading="$store.state.navLoading"
        :app-title="$store.state.appTitle"
        :nav-list="navList"
        :user-info="$store.getters.userInfo"
        :utility-list="utilityList"
      >
        Questions or comments about this site? Please send them to
        <a href="mailto:portal.support@live.jobcorps.org">
          portal.support@live.jobcorps.org <v-icon>mdi-email-outline</v-icon>
        </a>
      </jcdc-nav-router>
      <!-- <div class="d-flex justify-space-between align-center pr-6">
      <jcdc-breadcrumbs-vue />
      <jcdc-favorite />
    </div> -->
      <v-main>
        <v-container fluid class="pt-6">
          <jcdc-headline
            v-if="$route.meta.title"
            :title="$route.meta.title"
            :subtitle="$route.meta.subtitle"
          />
          <router-view />
        </v-container>
      </v-main>
      <jcdc-footer>
        <div class="text-right">
          Questions or comments about this site? Please send them to
          <a href="mailto:portal.support@live.jobcorps.org">
            portal.support@live.jobcorps.org <v-icon>mdi-email-outline</v-icon>
          </a>
        </div>
      </jcdc-footer>
    </div>
  </div>
</template>

<script>
import { navList, utilityList } from '@/router' // Get Nav list from router
import { mapActions } from 'vuex'
import {
  JcdcBrandBar,
  JcdcFooter,
  JcdcHeadline,
  JcdcNavRouter,
} from '@/components/jcdc/index'

export default {
  name: 'PageLayout',
  components: {
    JcdcBrandBar,
    JcdcFooter,
    JcdcHeadline,
    JcdcNavRouter,
  },
  data() {
    return {
      navList,
      utilityList,
    }
  },
  created() {
    this.$store.commit('SET_LOADING_APP', true)
  },
  methods: {
    ...mapActions(['getUserInfo']),
  },
}
</script>

<style lang="scss"></style>
